import type { CommunitySwitcher } from "../types/CommunitySwitcher";

export const applyVisibleReorder = (
  full: CommunitySwitcher[],
  visible: CommunitySwitcher[],
  nextVisible: CommunitySwitcher[],
): CommunitySwitcher[] => {
  const visibleSet = new Set(visible.map(c => c.id));
  let nextIndex = 0;
  return full.map(item => {
    if (visibleSet.has(item.id)) {
      const replacement = nextVisible[nextIndex];
      nextIndex += 1;
      return replacement ?? item;
    }
    return item;
  });
};
